import React, { Component } from 'react';
import {
    Button, Collapse, Select, Tabs, Empty, Switch, Row, Col,
    message, Space, notification, Popconfirm, Tag, Card, Popover, Spin
} from 'antd';
import { EditFilled, SecurityScanTwoTone } from '@ant-design/icons';
import {
    submitProject, approveProjectFg, approveProjectBoard,
    getProcessTasks, approveFunding, deleteProjectYear,
    submitProjectStatus, deleteProject
} from '../../util/APIUtils';
import { getCurrentStatusFromTasks, getCurrentTask } from '../../util/Helpers';
import Plan from './Plan';
import Calculation from './Calculation';
import Overview from './Overview';
import { withTranslation } from "react-i18next";
import { withRouter } from 'react-router-dom';
import StatusTimeline from './StatusTimeline';
import StatusTag from './StatusTag';
import ActionButtons from './ActionButtons';
import ProjectReport from './ProjectReport';
import ProjectComments from './ProjectComments';
import Lines from '../lines/Lines';
import PlanVa from './PlanVa';
import PlanGl from './PlanGl';
import PlanEz from './PlanEz';
import ProjectResources from './ProjectResources';
import { isPlanEditable, isReportEditable } from '../../util/ProjectStatusHelper';
import SortenBiographie from '../../sortenbiographie/SortenBiographie';
import ReportEz from '../project_report/ReportEz';
import ReportContainer from '../project_report/ReportContainer';
import ValidationContainer from '../../validations/ValidationContainer';
import CommentsList from '../../fg_review/CommentList';
import { Spa } from '@mui/icons-material';
// import Satz from '../../satz/Satz';

const { Panel } = Collapse;
const { TabPane } = Tabs;

class DetailContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: props.activeTab,
            loading: false,
            editing: false,
            approvalResponse: false,
            deletingProject: false,
            deleteProjectStatus: ''
        };
    }

    // Helper method to map new project types to their base types
    getMappedProjectType = (projectType) => {
        if (projectType === "SA-Si") {
            return "VA";
        }
        if (projectType === "SA-SB") {
            return "NZ";
        }
        return projectType;
    }

    setEditing = (val) => {
        this.setState({ editing: val });
    }

    submitMyProject = (description, review) => {
        const projectDetailYear = this.props.projectDetails ? this.props.projectDetails.find(o => o.year === this.props.year) : null;
        if (!projectDetailYear) {
            return;
        }
        let promise;
        promise = submitProjectStatus(projectDetailYear.id, description, review);

        if (!promise) {
            return;
        }
        this.setState({ isLoading: true });

        promise.then(response => {
            this.setState({ isLoading: false });
            this.getProcessInfo(projectDetailYear.processId);
            this.props.reloadProject({ 'year': this.props.year, "tab": 1 });
        }).catch(error => {
            console.log(error);
            this.setState({ isLoading: false });
        });
    }

    approveProject = (val, type, description, amount, review) => {
        const projectDetailYear = this.props.projectDetails ? this.props.projectDetails.find(o => o.year === this.props.year) : null;
        if (!projectDetailYear) {
            return;
        }
        let promise;
        if (type === "fg" || type === "fg_re") {
            promise = approveProjectFg(projectDetailYear.id, val, description, amount, review);
        } else if (type === "board") {
            promise = approveProjectBoard(projectDetailYear.id, val, description, amount);
        } else if (type === "report") {
            promise = approveFunding(projectDetailYear.id, val, description);
        }

        if (!promise) {
            return;
        }
        this.setState({ isLoading: true });

        promise.then(response => {
            if (response == null) {
                return;
            }
            console.log("Approved");

            this.setState({
                isLoading: false,
                approvalResponse: response
            })
            this.props.reloadProject({ 'year': this.props.year, "tab": 1 });

            message.success("Projekt bei FG eingereicht");
            if (!this.state.approvalResponse) {
                message.warn("Sie sind nicht berechtigt, diese Aufgabe zu genehmigen");
            }

            this.getProcessInfo(projectDetailYear.processId);

        }).catch(error => {
            console.log(error);
            message.warn("Sie sind nicht berechtigt, diese Aufgabe zu genehmigen");
            this.setState({ isLoading: false });
        });
    }

    getProcessInfo = (processId) => {
        let promise;
        promise = getProcessTasks(processId);

        if (!promise) {
            return;
        }
        this.setState({ isLoading: true });
        promise.then(response => {
            this.setState({ isLoading: false });
        }).catch(error => {
            console.log(error);
            this.setState({ isLoading: false });
        });
    }

    deleteProjectYearData = () => {
        const projectDetailYear = this.props.projectDetails ? this.props.projectDetails.find(o => o.year === this.props.year) : null;
        if (!projectDetailYear) {
            return;
        }
        let promise;
        promise = deleteProjectYear(projectDetailYear.id);

        if (!promise) {
            return;
        }
        this.setState({ isLoading: true });
        promise.then(response => {
            if (response) {
                notification.success({ message: "Kultursaat", description: "Projektjahr erfolgreich gelöscht", placement: 'topLeft' });
                this.props.reloadProject({ 'year': this.props.year, "tab": 1 });
            } else {
                notification.error({ message: "Kultursaat", description: "Projektjahr kann nicht gelöscht werden, Projekt nicht in ENTWURF", placement: 'topLeft' });
            }
            this.setState({ isLoading: false });
        }).catch(error => {
            console.log(error);
            notification.error({ message: "Kultursaat", description: "Projektjahr kann nicht gelöscht werden", placement: 'topLeft' });
            this.setState({ isLoading: false });
        });
    }

    deleteProjectData = () => {
        const projectId = this.props.projectInfo?.projectId || this.props.projectInfo?.id;
        if (!projectId) {
            notification.error({ message: "Kultursaat", description: "Projekt-ID fehlt oder ist ungültig", placement: 'topLeft' });
            return;
        }

        this.setState({ deletingProject: true, deleteProjectStatus: 'Checking dependencies...' });

        deleteProject(projectId)
            .then(response => {
                this.setState({ deletingProject: false, deleteProjectStatus: '' });
                if (response === 3) {
                    notification.error({ message: "Kultursaat", description: "Sie sind nicht berechtigt, dieses Projekt zu löschen", placement: 'topLeft' });
                } else if (response === 2) {
                    notification.error({ message: "Kultursaat", description: "Für das Projekt sind Daten aus früheren Projektjahren vorhanden, die nicht gelöscht werden können", placement: 'topLeft' });
                } else if (response == 0) {
                    notification.success({ message: "Kultursaat", description: "Projekt erfolgreich gelöscht", placement: 'topLeft' });
                    if (this.props.onProjectDeleted) {
                        this.props.onProjectDeleted();
                    } else {
                        this.props.history.goBack();
                    }
                    // Optionally, you can redirect the user or update the state to remove the deleted project
                } else {
                    notification.error({ message: "Kultursaat", description: "Projekt kann nicht gelöscht werden, Abhängigkeiten nicht erfüllt", placement: 'topLeft' });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ deletingProject: false, deleteProjectStatus: '' });
                notification.error({ message: "Kultursaat", description: "Projekt kann nicht gelöscht werden", placement: 'topLeft' });
            });
    }

    getPlan(projectType, currentStatus, isPlanEditable, projectDetailYear) {
        const mappedType = this.getMappedProjectType(projectType);

        switch (mappedType) {
            case "NZ":
                return <Plan
                    year={this.props.year}
                    projectInfo={this.props.projectInfo}
                    projectDetail={projectDetailYear}
                    editing={this.state.editing}
                    lineSelections={this.props.lineSelections}
                    breedingMethods={this.props.breedingMethods}
                    reloadProject={this.props.reloadProject}
                    workFlowState={currentStatus.name ? currentStatus.name : "NONE"}
                    isPlanEditable={isPlanEditable}
                    setEditingMaster={this.setEditing}
                    currentUser={this.props.currentUser}
                />;
            case "VA":
                return <PlanVa
                    year={this.props.year}
                    projectInfo={this.props.projectInfo}
                    projectDetail={projectDetailYear}
                    editing={this.state.editing}
                    lineSelections={this.props.lineSelections}
                    breedingMethods={this.props.breedingMethods}
                    reloadProject={this.props.reloadProject}
                    workFlowState={currentStatus.name ? currentStatus.name : "NONE"}
                    isPlanEditable={isPlanEditable}
                    setEditingMaster={this.setEditing}
                    currentUser={this.props.currentUser}
                />;
            case "GL":
                return <PlanGl
                    year={this.props.year}
                    projectInfo={this.props.projectInfo}
                    projectDetail={projectDetailYear}
                    editing={this.state.editing}
                    lineSelections={this.props.lineSelections}
                    breedingMethods={this.props.breedingMethods}
                    reloadProject={this.props.reloadProject}
                    workFlowState={currentStatus.name ? currentStatus.name : "NONE"}
                    isPlanEditable={isPlanEditable}
                    setEditingMaster={this.setEditing}
                    currentUser={this.props.currentUser}
                />;
            case "EZ":
                return <PlanEz
                    year={this.props.year}
                    cropId={this.props.projectInfo?.cropId}
                    projectInfo={this.props.projectInfo}
                    projectDetail={projectDetailYear}
                    editing={this.state.editing}
                    lineSelections={this.props.lineSelections}
                    breedingMethods={this.props.breedingMethods}
                    reloadProject={this.props.reloadProject}
                    workFlowState={currentStatus.name ? currentStatus.name : "NONE"}
                    isPlanEditable={isPlanEditable}
                    setEditingMaster={this.setEditing}
                    currentUser={this.props.currentUser}
                />;
            default:
                return <Empty description="Plan Not Available" />;
        }
    }

    getReport = (projectType, currentStatus, isReportEditable, projectDetailYear) => {
        const mappedType = this.getMappedProjectType(projectType);

        switch (mappedType) {
            case "NZ":
                return <ProjectReport
                    year={this.props.year}
                    currentUser={this.props.currentUser}
                    projectInfo={this.props.projectInfo}
                    projectDetail={projectDetailYear}
                    breedingMethods={this.props.breedingMethods}
                    lineSelections={this.props.lineSelections}
                    editing={this.state.editing}
                    reloadProject={this.props.reloadProject}
                    workFlowState={currentStatus ? currentStatus.name : "NONE"}
                    isReportEditable={projectDetailYear.reportEditable}
                />;
            case "VA":
            case "GL":
            case "EZ":
                return <ReportContainer
                    year={this.props.year}
                    cropId={projectType === "EZ" ? this.props.projectInfo?.cropId : undefined}
                    projectInfo={this.props.projectInfo}
                    projectDetailInfo={projectDetailYear}
                    editing={this.state.editing}
                    lineSelections={this.props.lineSelections}
                    breedingMethods={this.props.breedingMethods}
                    reloadProject={this.props.reloadProject}
                    workFlowState={currentStatus.name ? currentStatus.name : "NONE"}
                    isReportEditable={isReportEditable}
                    setEditingMaster={this.setEditing}
                />;
            default:
                return <Empty description="Report Not Available" />;
        }
    }

    changeTab = (activeTab) => {
        this.setState({ activeTab, editing: false });
    }

    render() {
        const { t } = this.props;
        const projectDetailYear = this.props.projectDetails.find(o => o.year === this.props.year);
        
        if (!projectDetailYear && this.props.year !== "Überblick") {
            return <Empty description="Year data not found" />;
        }

        let currentStatus = {};
        let currentTask = {};
        let currentActiveYear = this.props.currentUser?.projectYear?.projectYear;
        let showComments = true;
        if (currentActiveYear === this.props.year) {
            showComments = this.props.currentUser?.projectYear?.enableFgComments;
        }

        if (this.props.year !== "Überblick") {
            currentStatus = projectDetailYear != null ? getCurrentStatusFromTasks(projectDetailYear.projectDetailTasks) : null;
            currentTask = projectDetailYear != null ? getCurrentTask(projectDetailYear.projectDetailTasks) : null;
        }

        const mappedType = this.getMappedProjectType(this.props.projectInfo?.projectType);

        return (
            this.props.year !== "Überblick" ?
                <div>
                    <Tabs type="card"
                        activeKey={this.state.activeTab.toString()}
                        onChange={this.changeTab}
                        tabBarExtraContent={this.props.year === currentActiveYear || this.props.year === currentActiveYear - 1 ? <Space>
                            {projectDetailYear.submitted ? <Tag color="green">Eingereicht</Tag> : <Tag color="orange">Nicht eingereicht</Tag>}
                            
                            {(projectDetailYear.planEditable || projectDetailYear.reportEditable) ?
                                <ValidationContainer projectId={this.props.projectInfo?.projectId || this.props.projectInfo?.id} type="project" reloadProject={this.props.reloadProject} /> : ""}
                            <StatusTag status={currentStatus} />
                        </Space> : ""}>
                        <TabPane tab="Plan" key="1">
                            {this.getPlan(this.props.projectInfo?.projectType, currentStatus, projectDetailYear.planEditable, projectDetailYear)}
                        </TabPane>
                        <TabPane tab={t("general.calculation")} key="2">
                            <Calculation
                                year={this.props.year}
                                projectDetail={projectDetailYear}
                                accountingItems={this.props.accountingItems}
                                examinationItems={this.props.examinationItems}
                                editing={this.state.editing}
                                reloadProject={this.props.reloadProject}
                                workFlowState={currentStatus ? currentStatus.name : "NONE"}
                                isPlanEditable={projectDetailYear.planEditable}
                                isReportEditable={projectDetailYear.reportEditable}
                            />
                        </TabPane>
                        <TabPane tab={t("general.report")} key="3">
                            {this.getReport(this.props.projectInfo?.projectType, currentStatus, projectDetailYear.reportEditable, projectDetailYear)}
                        </TabPane>
                        {(mappedType === "NZ") && <TabPane tab={t("general.lines")} key="4">
                            <Lines
                                year={this.props.year}
                                projectDetailId={projectDetailYear.id}
                                projectId={this.props.projectInfo?.projectId || this.props.projectInfo?.id}
                                projectReportId={projectDetailYear.projectReportInfo?.id || 0}
                                currentStatus={currentStatus}
                                isReportEditable={projectDetailYear.reportEditable}
                                projectInfo={this.props.projectInfo}
                            />
                        </TabPane>}
                        <TabPane tab={t("general.status_timeline")} key="5">
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    {showComments &&
                                        <Card bordered title={"FG-Kommentare"}>
                                            <CommentsList currentUser={this.props.currentUser} itemId={projectDetailYear.id} />
                                        </Card>
                                    }
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tab={"Bilder & Dokumente"} key="6">
                            <ProjectResources projectId={this.props.projectInfo?.projectId || this.props.projectInfo?.id} year={currentActiveYear} currentUser={this.props.currentUser} />
                        </TabPane>
                        {(mappedType === "NZ") && <TabPane tab={"Sortenbiographie"} key="7">
                            <SortenBiographie
                                projectId={this.props.projectInfo?.projectId || this.props.projectInfo?.id}
                                year={this.props.year}
                                reportEditable={projectDetailYear.reportEditable}
                                reloadProject={this.props.reloadProject}>
                            </SortenBiographie>
                        </TabPane>}
                    </Tabs>
                    <div>
                        {!this.state.editing && (["1", "2"].includes(this.state.activeTab)) &&
                            <ActionButtons
                                currentUser={this.props.currentUser}
                                task={getCurrentStatusFromTasks(projectDetailYear.projectDetailTasks)}
                                cropId={this.props.projectInfo?.cropId}
                                breederId={this.props.projectInfo?.breederId}
                                approveProject={this.approveProject}
                                submitMyProject={this.submitMyProject}
                            />}
                    </div>
                    <br />
                    <div style={{ backgroundColor: 'lightyellow', padding: '10px', textAlign: 'center', borderRadius: '5px' }}>
                        <Space>
                            {projectDetailYear.planEditable &&
                             !(this.props.projectDetails?.length === 1 && Number(this.props.year) === this.props.currentUser?.projectYear?.projectYear) && (
                                <Popconfirm
                                    title="Möchten Sie das Projektjahr wirklich löschen?"
                                    onConfirm={this.deleteProjectYearData}>
                                    <Button type="danger" size='big'>Jahr löschen</Button>
                                </Popconfirm>
                            )}
                            {(this.props.currentUser?.roles?.find(x => x.name === 'ROLE_OFFICE') ||
                              (projectDetailYear.planEditable &&
                               this.props.currentUser?.breederInfo?.id === this.props.projectInfo?.breederId)) &&
                             this.props.projectDetails?.length === 1 &&
                             Number(this.props.year) === this.props.currentUser?.projectYear?.projectYear && (
                                <Popover content={<Spin spinning={this.state.deletingProject}>{this.state.deleteProjectStatus}</Spin>} title="Projekt löschen" trigger="click">
                                    <Popconfirm
                                        title="Möchten Sie das Projekt wirklich löschen?"
                                        onConfirm={this.deleteProjectData}>
                                        <Button type="danger" size='big'>Projekt löschen</Button>
                                    </Popconfirm>
                                </Popover>
                            )}
                        </Space>
                    </div>
                </div> : <Overview projectDetails={this.props.projectDetails} />
        );
    }
}

export default withTranslation()(withRouter(DetailContainer));
